<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path d="M21.49,7.13l-9-5a1,1,0,0,0-1,0l-9,5A1,1,0,0,0,2,8V21a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V15h4v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V8A1,1,0,0,0,21.49,7.13Z" />
  </svg>
</template>

<!--/////////////////////////////////////////////////////////////////////////-->

<script>
export default {
  name: 'icon-home'
}
</script>

<!--/////////////////////////////////////////////////////////////////////////-->

<style scoped lang="scss">
svg {
  fill: currentColor;
}
</style>
